module.exports = __webpack_public_path__ + "img/Logo_dark_border.0d5d48cd.svg";